var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.route},on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_c('inline-svg',{class:_vm.svgClass,attrs:{"src":_vm.getLogoSrc,"title":_vm.$t('welcome.logo')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }